export const drProfileEndPoint = '/api/doctorprofile';
export const contentfulEndPoint = '/contentful';
export const accountEndPoint = `/account`;
export const productsEndPoint = `/storeproducts`;
export const taxonEndPoint = '/taxons';
export const cartEndPoint = '/cart';
export const favouritesEndPoint = '/favourites';
export const checkoutEndPoint = '/checkout';
export const menuEndPoint = '/menus';
export const userEndPoint = '/users';
export const customClamshellDesignEndPoint = '/designs';
export const couponEndPoint = '/promotions';
export const designHuddleTokenEndPoint = '/dhtoken';
export const marketingMaterialProjectsEndpoint = '/reviews';
export const subscriptionEndpoint = '/subscriptions';

export const iteroEndpoint = '/itero';
export const productCacheEndpoint = `/productcaches`;
export const auth0UserInfoEndPoint = '/auth0userinfo';

export const dsoBootstrapEndPoint = `/dso/bootstrap`;
export const dsoPermissionsEndPoint = `/dso/permissions`;
export const dsoProductsEndPoint = `/dso/products`;
export const dsoCartEndPoint = `/dso/cart`;
export const dsoCheckoutEndPoint = `/dso/checkout`;
export const dsoOrdersEndpoint = `/dso/orders`;
export const dsoOrderHistoryEndpoint = `/dso/orders/history`;
export const dsoOrderHistoryFiltersEndpoint = `/dso/orders/filters`;
export const dsoTaxonEndPoint = '/dso/taxons';
export const dsoDiscountsEndPoint = '/dso/discounts';
export const dsoFavouriteEndPoint = '/dso/favourites';
export const dsoFavouriteToggleEndPoint = '/dso/favourites/toggle';
export const dsoIdsStoreSettingsEndPoint =
  '/dso/store_settings/get_config_settings';
export const dsoIdsStoreSettingsUpdateEndPoint =
  '/dso/store_settings/update_config_settings';
